import useEnergyConcessionaires from '~/store-v2/registration/useEnergyConcessionaires'
import useRegistration from '~/store-v2/registration/useRegistration'

export type DistributorInstallationGuardResult
  = { valid: true }
    | { valid: false }

export interface DistributorInstallationGuardInput {
  distributorId?: number | null
  installationState?: string | null
}

function normalizeState(value?: string | null): string {
  return (value ?? '').trim().toUpperCase()
}

/**
 * Dados do cliente: bloqueia só quando a concessionária e o endereço de instalação
 * estão em estados diferentes.
 */
export function useDistributorInstallationStateGuard(projectId: Ref<string>) {
  const { isFetched: registrationFetched } = useRegistration(projectId)
  const { data: concessionaires, isFetched: concessionairesFetched } = useEnergyConcessionaires(projectId)

  function validate(input?: DistributorInstallationGuardInput): DistributorInstallationGuardResult {
    if (!registrationFetched.value || !concessionairesFetched.value)
      return { valid: true }

    const distributorId = input?.distributorId == null ? null : Number(input.distributorId)
    const addressState = normalizeState(input?.installationState)

    if (distributorId == null || !addressState)
      return { valid: true }

    const concessionaire = (concessionaires.value ?? []).find(
      item => Number(item.id) === distributorId,
    )

    if (!concessionaire)
      return { valid: false }

    if (normalizeState(concessionaire.state) !== addressState)
      return { valid: false }

    return { valid: true }
  }

  return {
    validate,
  }
}
